import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col } from 'antd'
import '../../css/regimen.scss'
import { getAllCarePlans } from '../../store/action/device.action'
import DeviceCard from './deivce.card'
import leftArrow from '../../images/arrow_left.svg'
import rightArrow from '../../images/arrow_right.svg'
import { useWindowsSize } from '..'
import _ from 'lodash'

const DeviceList = (props) => {
  const ref = useRef(null)
  var size = useWindowsSize()
  const [limit, setLimit] = useState(1)
  const [offset, setOffset] = useState(0)

  var shiftRight = () => setOffset(limit + offset)
  var shiftLeft = () => setOffset(offset - limit)

  useEffect(() => {
    var wdth = ref.current ? ref.current.offsetWidth : 0
    setLimit(Math.floor(wdth / 280))
  }, [ref.current, size.width])

  useEffect(() => {
    props.fetchCareplans({ companyid: props.company?._id || props.customer?.company, customerid: props.customer._id })
  }, [])

  useEffect(() => {
    setOffset(0)
  }, [props.filters])

  var renderCards = () => {
    const { careplans } = { ...props }
    return careplans
      ? careplans.map((plan, index) => {
          return index >= offset && index <= offset + limit - 1 ? (
            <DeviceCard plan={plan} />
          ) : null
        })
      : null
  }

  return (
    <Row className='filterListContainer'>
      <Col flex={'25px'}>
        <img
          hidden={offset + 1 - limit <= 0}
          onClick={shiftLeft}
          className='arrowIcon'
          src={rightArrow}
          height={35}
          width={24}
        />
      </Col>
      <Col style={{ width: '100%' }} flex={'auto'}>
        <div ref={ref} style={{ height: '100%' }}>
          <Row style={{ height: '100%' }} justify='space-around' align='middle'>
            {renderCards()}
          </Row>
        </div>
      </Col>
      <Col flex={'25px'}>
        <img
          hidden={offset + limit >= props.careplans?.length}
          onClick={shiftRight}
          className={'arrowIcon'}
          src={leftArrow}
          height={35}
          width={24}
        />
      </Col>
    </Row>
  )
}

DeviceList.propTypes = {
  company: PropTypes.object,
  devices: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    company: state.profile.company,
    careplans: state.device.careplans,
    devices: state.device?.devices,
    assignedDevices: state?.device?.assignedDevices,
    assignedPlan: state.device.assignedPlan,
    filters: state?.device?.filters,
    customer: state.profile.customer,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCareplans: (args) => dispatch(getAllCarePlans(args)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceList)
